<!-- =========================================================================================
    File Name: Error500.vue
    Description: 500 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/musubell_logo_color_yoko.png" alt="graphic-500" class="mx-auto mb-4">
            <h4 class="mt-3 sm:mx-0 mx-4 sm:mb-12 d-theme-heading-color">不適切な利用を検知しました。<br>詳細は貴社システム担当者までお問い合わせください。<br>なお、ご入力されたデータは保存されませんので予めご了承ください。</h4>
            <vs-button size="large" @click="redirect()">ログイン画面へ戻る</vs-button>
        </div>
    </div>
</template>
<script>
export default {
  methods: {
    redirect() {
      const mAgentURL = process.env.VUE_APP_BASE_HOST_MUSUBELL_AGENT
      if(!process.env.VUE_APP_BASE_URL.startsWith('https')) {
        this.$router.push('/')
      } else {
        window.location.href = `${mAgentURL}/login`
      }
    }
  }
}
</script>
